import React from 'react';

import PositionedGoodyHOC from '../PositionedGoodyHOC';
import { POSITIONED_GOODY_REFS } from '../../../../constants';

export default class TopHat extends PositionedGoodyHOC {
	render() {
		return (
			<g>
				<circle ref={POSITIONED_GOODY_REFS.MARKER} cx="32.7272" cy="60.7006" />
				<path fill="#444444" d="M32.72672,0C21.76777,0,14.1874,1.17435,10.53195,1.90492C9.10499,2.19011,8.13991,3.5127,8.29139,4.95997
					l2.64323,25.25459l43.5843-0.00002l2.64339-25.25455c0.15149-1.44728-0.81359-2.76988-2.24055-3.05507
					C51.26627,1.17435,43.68585,0,32.72672,0z" />
				<path fill="#ffffff" d="M54.519,30.21455c-14.52808-0.00024-29.0564-0.00024-43.58423,0l1.75049,16.7251l20.0415,3.51147
					l20.0415-3.51147L54.519,30.21455z" />
				<path fill="#444444" d="M32.72702,55.57523c17.60231,0,26.90208-2.3328,31.333-6.35959
					c2.94451-2.67595,0.86792-8.04698-2.89868-7.47179c-19.06079,2.9104-38.01611,2.90771-56.86841,0
					c-3.76563-0.58081-5.84328,4.79579-2.8988,7.47176C5.82498,53.24241,15.12468,55.57523,32.72702,55.57523z" />
			</g>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/Global/Goodies/Hat/TopHat.js